import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { downloadFileTrigger } from '@dealstack/frontend/shared/files/downloadFile';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { BulkDownloadFileDto } from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { Button } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

const bulkDownloadFilesRequest = async ({
	dealId,
	programmeId,
	body,
}: {
	dealId: string;
	programmeId: string;
	body: BulkDownloadFileDto;
}) => {
	const response = await makeRequest<ApiV1.Response<{ downloadUrl: string; isAsync: boolean }>>({
		endpoint: formatUnicorn(
			API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_BULK_DOWNLOAD_POST,
			{
				dealId,
				programmeId,
			}
		),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(body),
	});
	return response;
};

export const useBulkFileDownload = ({
	tDocuments,
}: {
	tDocuments: TranslateFunction<I18Namespaces.DOCUMENT_LIBRARY>;
}) => {
	const navigate = useNavigate();
	return useMutation({
		mutationFn: bulkDownloadFilesRequest,
		onSuccess: (preSignedUrl) => {
			if (preSignedUrl.payload?.isAsync) {
				showToastV2({
					title: tDocuments('modals.bulk-download.title'),
					state: 'success',
					message: (
						<div>
							<p>{tDocuments('modals.bulk-download.async-message')}</p>
							<Button
								variant="white"
								onClick={() => navigate('/exports', { replace: true })}
							>
								{tDocuments('modals.bulk-download.go-button')}
							</Button>
						</div>
					),
				});
				return;
			}

			if (preSignedUrl.payload?.downloadUrl) {
				downloadFileTrigger(preSignedUrl.payload.downloadUrl);
			}
		},
	});
};
